import * as React from 'react';
export const americansavingsSvg = React.forwardRef(
  function americansavingsSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#163963',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M6.11 16.09c-2.37 8.385 2.876 4.524 3.636 4.505.77-.01.83 1.872 1.014 3.802.195 1.93 1.414 3.958 5.119 1.365s12.05-8.658 8.94-19.47c0 0-15.112-2.934-18.71 9.798Z',
        fill: '#A3CE5F',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'm12.857 11.713 1.12 4.241-5.342 2.33 5.372-1.462-1.365 6.044 2.262-5.615 4.173 2.876-3.647-3.607 6.104-6.406-6.445 5.42-2.223-3.821h-.01Z',
        fill: '#FEFEFE',
      }),
    );
  },
);
americansavingsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var americansavings = {
  category: 'brand',
  colorable: false,
  name: 'americansavings',
  svg: americansavingsSvg,
};
